import { gql } from '@apollo/client';

export const DELETE_KIDS_PROFILE = gql`
  mutation DeleteDependent($id: UUID) {
      deleteDependent(id: $id)
    }
`;
